import { render, staticRenderFns } from "./ManagedDevices.vue?vue&type=template&id=b976454a&scoped=true&"
import script from "./ManagedDevices.vue?vue&type=script&lang=ts&"
export * from "./ManagedDevices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b976454a",
  null
  
)

export default component.exports